export default __webpack_public_path__ + "static/media/tutorial-1.b226a1e7.svg";